module.exports = __webpack_public_path__ + "img/gt1686608157743.b543c45e.jpg";